import React, { Component } from "react";
import { registerForLocalization, provideLocalizationService } from "@progress/kendo-react-intl";
import LoadingPanel from "../../common/LoadingPanel";
import { dateConvert } from "../../common/Helpers";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { nahlasenieDodavkyController } from "../../../controllers/nahlaseniedodavky.controller";

class NahlasenieBaliky extends Component {
    state = { items: [], loading: true };

    shouldComponentUpdate(nextProps) {
        if (this.props.idNahlasenie !== nextProps.idNahlasenie) {
            this.getNahlasenieBalikyByIdNahlasenie(nextProps.idNahlasenie);
            return false;
        }
        return true;
    }

    componentDidMount() {
        this.getNahlasenieBalikyByIdNahlasenie(this.props.idNahlasenie);
    }

    getNahlasenieBalikyByIdNahlasenie(idNahlasenie) {
        nahlasenieDodavkyController.getNahlasenieBaliky(idNahlasenie).then(ajaxData => {
            let data = JSON.parse(JSON.stringify(ajaxData), dateConvert);
            this.setState({
                items: data,
                loading: false
            });
        });
    }

    renderTable(items) {
        var localizationService = provideLocalizationService(this);

        return (
            <div id="NahlasenieBaliky">
                <Grid
                    data={items}
                    total={items ? items.length : 0}
                    pageSize={items ? items.length : 0}
                    pageable={{ buttonCount: 0, info: true, pageSizes: false, previousNext: false }}>
                    <GridColumn field="ciarovyKod" title={localizationService.toLanguageString("NahlasenieBaliky.Grid.Balík/Lot", "Balík/Lot")} />
                    <GridColumn field="typTovaru" title={localizationService.toLanguageString("NahlasenieBaliky.Grid.Typ", "Typ")} width="35px" />
                    <GridColumn field="pocetKs" title={localizationService.toLanguageString("NahlasenieBaliky.Grid.Ks", "Ks")} width="35px" />
                    <GridColumn field="balTextPotvrdenieStav" title={localizationService.toLanguageString("NahlasenieBaliky.Grid.Stav B/L", "Stav B/L")} />
                    <GridColumn field="textPotvrdenieStav" title={localizationService.toLanguageString("NahlasenieBaliky.Grid.Stav ks", "Stav ks")} />
                    <GridColumn field="skutPocetKs" title={localizationService.toLanguageString("NahlasenieBaliky.Grid.Skut.ks", "Skut.ks")} width="55px" />
                </Grid>
            </div>
        );
    }

    render() {
        let contents = this.state.loading ? <LoadingPanel /> : this.renderTable(this.state.items);

        return <div>{contents}</div>;
    }
}

export default NahlasenieBaliky;

registerForLocalization(NahlasenieBaliky);



// WEBPACK FOOTER //
// ./src/components/dialogs/NahlasenieDodavky/NahlasenieBaliky.js